import { OTHER_VALUE } from './fields-values';

export default {
  SERVICE: 'service',
  NEW_WEBSITE_DESCRIPTION: 'what_is_the_nature_of_your_business_and_purpose_of_your_website',
  NEW_WEBSITE_CONTENT: 'do_you_have_content_ready_for_your_website',
  NEW_WEBSITE_CONTENT_TYPES: 'what_content_elements_do_you_currently_have_ready_for_your_website',
  NEW_WEBSITE_CONTENT_OTHER_TYPE: `content_${OTHER_VALUE}_type`,
  NEW_WEBSITE_EXPECTED_FEATURES:
    'what_features_and_functionality_would_you_like_to_have_on_your_website',
  WEBSITE_DESCRIPTION: 'what_is_your_site_purpose_and_what_kind_of_content_does_it_present',
  WEBSITE_EXPECTED_IMPROVEMENTS: 'what_would_you_like_to_improve_your_site_with',
  MIGRATION_WEBSITE_URL: 'current_website_url',
  MIGRATION_PLATFORM: 'what_platform_or_cms_do_you_want_to_migrate_your_website_from',
  MIGRATION_PLATFORM_OTHER: `migration_platform_${OTHER_VALUE}`,
  MIGRATION_REASON: 'why_do_you_want_to_migrate_from_your_existing_platform',
  MIGRATION_REASON_OTHER: `migration_reason_${OTHER_VALUE}`,
  MIGRATION_EXPECTED_IMPROVEMENTS:
    'is_there_anything_you_would_like_to_change_or_improve_while_migrating_the_website',
  CONTACT_INFO_USER_FULL_NAME: 'user_full_name',
  CONTACT_INFO_USER_EMAIL: 'user_email',
  CONTACT_INFO_USER_PHONE: 'user_phone',
};
